export default "__VITE_ASSET__ff5b0264__"